import React, { useEffect, useState, useMemo } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useTroopScheduleStep = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  selectModeParamData
) => {
  const [data, setData] = useState([]); /* TrOOP Schedule Step Data */

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const { axios_helper_no_header, cancelRequest } = useAxios();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();

  const { TROOP_SCHEDULE } = ROUTE_PATHS;

  /*const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return { currentState, previousState };
  }, [stateVal]);

  /*const {
    selectedSchedules = [],
    previousScreen = TROOP_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;*/

  const {
    selectedSchedules,
    previousScreen,
    initialIndex,
    initialExternalMode,
  } = useMemo(() => {
    let {
      selectedSchedules = [],
      previousScreen = TROOP_SCHEDULE,
      currentIndex: initialIndex = 0,
      externalMode: initialExternalMode = false,
    } = currentState;
    return {
      selectedSchedules,
      previousScreen,
      initialIndex,
      initialExternalMode,
    };
  }, [currentState]);

  const {
    TROOP_SCHEDULE_STEP_ADD,
    TROOP_SCHEDULE_STEP_EDIT,
    TROOP_SCHEDULE_STEP_DISPLAY,
  } = ROUTE_PATHS;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const screen_title = "TrOOP Schedule Step";
  const screenNumber = "RCTSD001";
  const initialParams = selectMode
    ? selectModeParamData
    : {
        tscScheduleName: selectedSchedules[currentIndex]?.tscScheduleName,
        tscDescription: selectedSchedules[currentIndex]?.tscDescription,
        tscVersion: selectedSchedules[currentIndex]?.tscVersion,
        tscCrossOverFlag: selectedSchedules[currentIndex]?.tscCrossOverFlag,
        tscTroopAccumCompCode:
          selectedSchedules[currentIndex]?.tscTroopAccumCompCode,
        tscDrugSpendAccumComp:
          selectedSchedules[currentIndex]?.tscDrugSpendAccumComp,
        tscCoverageGapCalc: selectedSchedules[currentIndex]?.tscCoverageGapCalc,
      };

  const fetchDataParam = useMemo(
    () => ({
      tscScheduleName: selectMode
        ? selectModeParamData?.tscScheduleName
        : selectedSchedules[currentIndex]?.tscScheduleName,
    }),
    [currentIndex, selectMode, selectedSchedules]
  );

  const [paramsData, setParamsData] = useState(initialParams); /* */
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "tscScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "tscDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Version",
      name: "tscVersion",
      label: "Version",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "TSC Cross Over Flag*ALL values",
      name: "tscCrossOverFlag",
      label: "Cross Over",
      fieldNature: "readOnly",
      type: "dropdown",
      value: "",
      maxLength: 1,
    },
    {
      fieldLabel: "TSC Troop Accum Comp Code*ALL values",
      name: "tscTroopAccumCompCode",
      label: "TrOOP Accum Code",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    ...(selectedSchedules[currentIndex]?.tscVersion !== "01"
      ? [
          {
            fieldLabel: "TSD Drug Spend Accum Comp*ALL values",
            name: "tscDrugSpendAccumComp",
            label: "Drug Spend Accum Code",
            type: "dropdown",
            fieldNature: "readOnly",
            value: "",
            maxLength: 2,
          },
        ]
      : []),
    ...(selectedSchedules[currentIndex]?.tscVersion !== "01"
      ? [
          {
            fieldLabel: "TSC Coverage Gap Calc*ALL values",
            name: "tscCoverageGapCalc",
            label: "Coverage Gap Calc",
            type: "dropdown",
            fieldNature: "readOnly",
            value: "",
            maxLength: 1,
          },
        ]
      : []),
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "TSC Cross Over Flag", condition: "*ALL values" },
    { field_label: "TSC Troop Accum Comp Code", condition: "*ALL values" },
    { field_label: "TSD Drug Spend Accum Comp", condition: "*ALL values" },
    { field_label: "TSC Coverage Gap Calc", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add TrOOP Schedule Step",
          button_handeler: () => {
            navigateToPage(TROOP_SCHEDULE_STEP_ADD, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                previousScreen: location.pathname,
                tscScheduleName: paramsData?.tscScheduleName,
              },
            ]);
          },
          button_key: "F6",
        },
        // {
        //   button_label: "Back",
        //   button_handeler: () => {
        //     navigateToPage(DISPLAY_TROOP_SCHEDULE_STEP);
        //   },
        //   button_key: "F12",
        // },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? []
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(TROOP_SCHEDULE_STEP_EDIT, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                tscScheduleName: paramsData?.tscScheduleName,
                currentIndex: 0,
                paramsData: paramsData,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(TROOP_SCHEDULE_STEP_DISPLAY, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                tscScheduleName: paramsData?.tscScheduleName,
                currentIndex: 0,
                paramsData: paramsData,
              },
            ]);
          },
        },
      ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Step",
      field: "tsdStepNumber",
    },
    {
      header: "TrOOP Amount",
      field: "tsdTroopAmount",
    },
    ...(selectedSchedules[currentIndex]?.tscVersion !== "01"
      ? [
          {
            header: "Drug Spend",
            field: "tsdDrugSpend",
          },
        ]
      : []),
    {
      header: "Plan Override",
      field: "planCode",
    },
    {
      header: "Patient Pay Schedule",
      field: "tsdSchedFlag",
    },
    {
      header: "Brand Copay Amount",
      field: "tsdBrandCopayAmount",
    },
    {
      header: "Brand Percent Amount",
      field: "tsdBrandPercentAmt",
    },
    {
      header: "Generic Copay Amount",
      field: "tsdGenericCopayAmount",
    },
    {
      header: "Generic Percent Amount",
      field: "tsdGenericPercentAmt",
    },
    {
      header: "Message Code Indicator",
      field: "messageCodeIndicator",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "tsdStepNumber";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    cancelRequest();
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/troopScheduleDetail`,
        null,
        {
          page: page,
          size: rows,
          ...fetchDataParam,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, fetchDataParam]);
  useEffect(() => {
    const fetchParamData = async () => {
      const url = `api/tscTroopScheduleCtl/${encodeURIComponent(
        selectModeParamData?.tscScheduleName
      )}`;
      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setParamsData(responseData);
      } catch (e) {
        console.error(e);
      }
    };
    if (selectMode) fetchParamData();
  }, [selectMode]);

  useEffect(() => {
    !selectMode &&
      setParamsData({
        tscScheduleName: selectedSchedules[currentIndex]?.tscScheduleName,
        tscDescription: selectedSchedules[currentIndex]?.tscDescription,
        tscVersion: selectedSchedules[currentIndex]?.tscVersion,
        tscCrossOverFlag: selectedSchedules[currentIndex]?.tscCrossOverFlag,
        tscTroopAccumCompCode:
          selectedSchedules[currentIndex]?.tscTroopAccumCompCode,
        tscDrugSpendAccumComp:
          selectedSchedules[currentIndex]?.tscDrugSpendAccumComp,
        tscCoverageGapCalc: selectedSchedules[currentIndex]?.tscCoverageGapCalc,
      });
  }, [currentIndex, selectMode]);

  useEffect(() => {
    setCurrentIndex(initialIndex);
    !selectMode &&
      setParamsData({
        tscScheduleName: selectedSchedules[initialIndex]?.tscScheduleName,
        tscDescription: selectedSchedules[initialIndex]?.tscDescription,
        tscVersion: selectedSchedules[initialIndex]?.tscVersion,
        tscCrossOverFlag: selectedSchedules[initialIndex]?.tscCrossOverFlag,
        tscTroopAccumCompCode:
          selectedSchedules[initialIndex]?.tscTroopAccumCompCode,
        tscDrugSpendAccumComp:
          selectedSchedules[initialIndex]?.tscDrugSpendAccumComp,
        tscCoverageGapCalc: selectedSchedules[initialIndex]?.tscCoverageGapCalc,
      });
  }, [initialIndex, selectedSchedules, selectMode]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteTroopScheduleStep = () => {
    if (selectedOption === "yes") {
      const params = {
        tscScheduleName: paramsData?.tscScheduleName,
        tsdStepNumber: rowData?.tsdStepNumber,
      };
      axios_helper_no_header("DELETE", "api/troopScheduleDetail", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/troopScheduleDetail/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteTroopScheduleStep,
    setSelectedOption,
  };
};

export default useTroopScheduleStep;
